import {
    copySelectedNode,
    cutSelectedNode,
    deleteSelectedNode,
    pasteSelectedNode
} from "@builder/components/app/OliverBuildFrame/copyPaste/functions";
import useSaveBuildSettingsKey from "@builder/hooks/useSaveBuildSettingsKey";
import { redoBuildState, undoBuildState } from "@builder/store/slices/BuilderSlice/builderSlice";
import { useSaveBuildMutation } from "@builder/store/slices/BuildsApiSlice/buildsApiSlice";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import toast from "react-hot-toast";
import { useHotkeys } from "react-hotkeys-hook";
import { useTranslation } from "react-i18next";

const useGlobalHotkeys = () => {
    const dispatch = useAppDispatch();
    const isBuildPast = useAppSelector(state => state.builder.buildHistory.past.length);
    const isBuildFuture = useAppSelector(state => state.builder.buildHistory.future.length);
    const { isLoading, save: saveBSK } = useSaveBuildSettingsKey();
    const [saveBuild, { isLoading: saveBuildLoading }] = useSaveBuildMutation();
    // const companyId = useAppSelector(state => state.storeData.company?._id || "");
    const companyId = useAppSelector(state => state.builder.build.companyId);
    const build = useAppSelector(state => state.builder.build);
    const { t } = useTranslation();

    const isEditable = (el: Element | null) => {
        if (!el) return false;
        const element = el as HTMLElement;
        const tagName = element.tagName;
        if (element.isContentEditable) return true;
        return tagName === "INPUT" || tagName === "TEXTAREA" || tagName === "SELECT";
    };

    const hasUserSelection = () => {
        const selection = window.getSelection?.();
        return !!selection && !selection.isCollapsed && selection.toString().trim().length > 0;
    };

    //Windows
    useHotkeys(["ctrl+s", "meta+s"], async e => {
        e.preventDefault();
        if (!saveBuildLoading && !isLoading && companyId) {
            if (companyId) {
                try {
                    await saveBuild({ companyId, build }).unwrap();
                    await saveBSK();
                    toast.success(t("toast.buildSaved"));
                } catch (error) {
                    console.error("error", error);
                    toast.error(t("toast.buildSaveFailed"));
                }
            }
        }
    });
    useHotkeys(["ctrl+z", "meta+z"], e => {
        e.preventDefault();
        if (isBuildPast) {
            dispatch(undoBuildState());
        }
    });
    useHotkeys(["ctrl+shift+z", "meta+shift+z", "ctrl+y", "meta+y"], e => {
        e.preventDefault();
        if (isBuildFuture) {
            dispatch(redoBuildState());
        }
    });
    useHotkeys(["ctrl+c", "meta+c"], e => {
        if (isEditable(document.activeElement) || hasUserSelection()) return;
        e.preventDefault();
        copySelectedNode();
    });
    useHotkeys(["ctrl+shift+c", "meta+shift+c"], e => {
        if (isEditable(document.activeElement) || hasUserSelection()) return;
        e.preventDefault();
        copySelectedNode({ zip: false });
    });
    useHotkeys(["ctrl+x", "meta+x"], e => {
        if (isEditable(document.activeElement) || hasUserSelection()) return;
        e.preventDefault();
        cutSelectedNode();
    });
    useHotkeys(["ctrl+v", "meta+v"], e => {
        if (isEditable(document.activeElement)) return;
        e.preventDefault();
        pasteSelectedNode();
    });
    useHotkeys(["delete", "backspace"], e => {
        if (isEditable(document.activeElement)) return;
        e.preventDefault();
        deleteSelectedNode();
    });
};

export default useGlobalHotkeys;
